import React from 'react';
import moment from 'moment';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
} from '@material-ui/core';
import { Cancel } from '@material-ui/icons';
import { IRealEstateEvent } from '../interfaces';

const useStyles = makeStyles({
  table: {
    '& thead': {
      '& th': {
        fontWeight: 600,
        backgroundColor: '#FDD7E7',
      },
    },

    '& tbody': {
      '& tr': {
        '& td': {
          backgroundColor: '#FAFAFA',
        },
      },
    },
  },
});

interface IProps extends DialogProps {
  realEstateEvent: IRealEstateEvent;
  onClose(): void;
}

const EventHistoryDialog = ({ realEstateEvent, onClose, ...props }: IProps) => {
  // Styles
  const classes = useStyles();

  return (
    <Dialog {...props} onClose={onClose} fullWidth maxWidth="md" scroll="body">
      <DialogTitle>
        <b>История изменений</b>
      </DialogTitle>

      <DialogContent dividers>
        <TableContainer component={Box} sx={{ my: -2, mx: -3, width: 'calc(100% + 48px) !important' }}>
          <Table size="small" stickyHeader className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Тип события</TableCell>
                <TableCell>Дата начала</TableCell>
                <TableCell>Дата окончания</TableCell>
                <TableCell>Пользователь</TableCell>
                <TableCell>Примечание</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {realEstateEvent.history?.map((history, index) => (
                <TableRow key={index}>
                  <TableCell>{history.realEstateEventTypeName}</TableCell>
                  <TableCell>{moment(history.eventStartTime).format('DD.MM.YYYY HH:mm')}</TableCell>
                  <TableCell>{moment(history.eventEndTime).format('DD.MM.YYYY HH:mm')}</TableCell>
                  <TableCell>{history.userName}</TableCell>
                  <TableCell>{history.comment ?? '—'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions>
        <Button variant="contained" onClick={onClose} startIcon={<Cancel />}>
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EventHistoryDialog;
